/* eslint-disable */
import { connect } from 'react-redux';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import styles from './ImageModal.module.scss';
import { Eye } from 'lucide-react';
import { useState } from 'react';
import { urls } from '@/Constants';
import { useHistory } from 'react-router-dom';
import { Button } from 'rsuite';
import { handleImagePreview } from '@/Helpers';

const ImageModal = (props) => {
	const { show, toggleModal, data, children } = props;
	const [hoveredImage, setHoveredImage] = useState(null);
	const history = useHistory();

	const handleClose = () => {
		toggleModal(false);
	};
	const { image, heading, qcId, qrCode, showBtn=false} = data;

	const handleBtn = () => {
		return (
			<Button 
				onClick={() => history.push(`${urls.EXTENSION}${urls.PAST_QC}/${qrCode}?id=${qcId}`)}
				className='p-2 rounded-md bg-blue-500 text-white'
			>
				View Scan
			</Button>
		);
	};

	return (
		// eslint-disable-next-line react/jsx-boolean-value
		<BaseModal
			heading={heading}
			open={show}
			handleClose={handleClose}
			renderBtns={showBtn ? handleBtn : () => {}}
			width={data?.width}
			height={data?.height}
		>
			{Array.isArray(image) && image?.length > 0 ? (
					<div className='flex justify-start items-center gap-4'>
						{image?.map((imgSrc, index) => (
							<div 
								className='relative group' 
								key={index} 
								onMouseEnter={() => setHoveredImage(imgSrc)}
								onMouseLeave={() => setHoveredImage(null)}
						>
							{/* Image */}
							<img src={imgSrc} alt='' className='w-[200px] h-[200px] m-2 rounded-lg shadow-md' />

							{/* Hover Preview Icon */}
							{hoveredImage === imgSrc && (
								<div 
									className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-50  cursor-pointer'
									onClick={() => handleImagePreview(imgSrc)} // Open modal on click
								>
									<Eye className='text-white w-8 h-8' />
								</div>
							)}
						</div>
					))}
					</div>
			) : (
					<div className={`${styles.root}`}>
						<img
							src={image}
							alt=''
							style={{	
								display: data?.centerImage ? 'block' : 'block',
								margin: data?.centerImage ? '0 auto' : 0,
							}}
						/>
					</div>
			)}
			{children}
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.imageModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleImageModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageModal);
